/**
 * cookieにセットするための、Akamai tokenを含めた文字列を生成する
 *
 * 外部から期限が与えられる場合はそれを用いる
 * 与えられない場合は、現在から24時間後までを期限とする
 * */
export const buildCookie = (token: string, expiresAt?: string): string => {
  if (token === '') {
    return ''
  }
  if (expiresAt) {
    return `${token}; path=/; domain=juno.zkai.co.jp; expires=${expiresAt}; SameSite=None; Secure;`
  }

  const d = new Date()
  d.setTime(d.getTime() + 24 * 60 * 60 * 1000) // in milliseconds
  return token === ''
    ? ''
    : `${token}; path=/; domain=juno.zkai.co.jp; expires=${d.toUTCString()}; SameSite=None; Secure;`
}
